import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {
    Center,
    Loader
} from '@mantine/core';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from '@flexinet/auth-components';


export const OffersLayout = () => {

    const {allowedActions, authorizing} = useVerifiedPermissions();

    // FNP-1731: allowedActions is empty until the check settles; deciding before
    // then sends a signed-in deep link away from the page it asked for.
    if (authorizing) {
        return <Center><Loader/></Center>;
    }

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListOffers') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetOffer') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/offers'/>
                    )
                }
            />
        </Routes>
    );
};
